import React from "react"

import { AstroHeader, AstroHeaderCard, AstroHeaderImage, CardsContainer } from "./styles"

const Top = ({ isArticle }) => (
  <AstroHeader id="astro-header" isArticle={isArticle}>
    <CardsContainer isArticle={isArticle}>
      <AstroHeaderCard to="/astrology">
        <AstroHeaderImage
          baseUrl="https://mindbodygreen-res.cloudinary.com/image/upload/v1591947134/astro/dailyhoroscope.png"
          images={[{ transforms: "c_fill,g_auto,w_56,h_56,q_auto,f_auto,fl_lossy" }]}
          alt="Daily horoscope"
        />
        <div>
          <h4>Daily Horoscope</h4>
          <p>Check for daily updates on your sun sign</p>
        </div>
      </AstroHeaderCard>
      <AstroHeaderCard to="/astrology/forecasts">
        <AstroHeaderImage
          baseUrl="https://mindbodygreen-res.cloudinary.com/image/upload/v1591947145/astro/astrologyforecasts.png"
          images={[{ transforms: "c_fill,g_auto,w_56,h_56,q_auto,f_auto,fl_lossy" }]}
          alt="Current events"
        />
        <div>
          <h4>Current Events</h4>
          <p>Moon phases, seasons, and other current happenings</p>
        </div>
      </AstroHeaderCard>
      {/* <AstroHeaderCard to="/astrology/basics">
      <AstroHeaderImage
        baseUrl="https://mindbodygreen-res.cloudinary.com/image/upload/v1604571125/astro/astrologybasics.png"
        images={[{ transforms: "c_fill,g_auto,w_56,h_56,q_auto,f_auto,fl_lossy" }]}
      />
      <div>
        <h4>Astrology Basics</h4>
        <p>Learn the basics of your sign and how astrology works</p>
      </div>
    </AstroHeaderCard> */}
    </CardsContainer>
  </AstroHeader>
)

export default Top
